import { jsx as _jsx } from "react/jsx-runtime";
import ImageProxyRenderer from "../image";
const BMPRenderer = (props) => _jsx(ImageProxyRenderer, Object.assign({}, props));
BMPRenderer.fileTypes = ["bmp", "image/bmp"];
BMPRenderer.weight = 0;
export default BMPRenderer;
